<template>
  <div class="pageContol listWrap templateList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">数据统计</a>
          <i>></i>
          <a href="javascript:;" @click="init" class="cur-a">{{
            projectName ? projectName : "学员学习记录"
          }}</a>
        </span>
      </div>
      <div class="framePage-body">
        <div
          class="operationControl"
          style="display: flex; flex-direction: column; align-items: flex-start"
        >
          <div class="searchbox">
            <div title="姓名" class="searchboxItem ci-full">
              <span class="itemLabel">姓名:</span>
              <el-input
                v-model="userName"
                type="text"
                size="small"
                placeholder="请输入姓名"
                clearable
              />
            </div>
            <div title="身份证号" class="searchboxItem ci-full">
              <span class="itemLabel">身份证号:</span>
              <el-input
                v-model="idCard"
                type="text"
                size="small"
                placeholder="请输入身份证号"
                clearable
              />
            </div>
            <div
              title="行政区划"
              class="searchboxItem ci-full"
              v-show="screen != 'screen'"
            >
              <span class="itemLabel">行政区划:</span>
              <el-cascader
                v-model="areaId"
                :options="areatreeList"
                clearable
                :props="propsarea"
                size="small"
              ></el-cascader>
            </div>
            <div
              title="所属企业"
              class="searchboxItem ci-full"
              v-show="screen == 'screen'"
            >
              <span class="itemLabel">所属企业:</span>
              <el-select
                size="small"
                v-model="userCompId"
                remote
                :remote-method="getuserCompanyList"
                filterable
                clearable
                placeholder="请至少输入两个字搜索"
                style="width: 100%"
              >
                <el-option
                  v-for="item in userCompanyList"
                  :key="item.compId"
                  :label="item.compName"
                  :value="item.compId"
                ></el-option>
              </el-select>
            </div>
            <div
              title="课程名称"
              class="searchboxItem ci-full"
              v-show="screen == 'screen'"
            >
              <span class="itemLabel">课程名称:</span>
              <el-input
                v-model="CourseName"
                type="text"
                size="small"
                placeholder="请输入课程名称"
                clearable
              />
            </div>
          </div>
          <div class="searchbox" style="padding-top: 10px">
            <div
              title="所属企业"
              class="searchboxItem ci-full"
              v-show="screen != 'screen'"
            >
              <span class="itemLabel">所属企业:</span>
              <el-select
                size="small"
                v-model="userCompId"
                remote
                :remote-method="getuserCompanyList"
                filterable
                clearable
                placeholder="请至少输入两个字搜索"
                style="width: 100%"
              >
                <el-option
                  v-for="item in userCompanyList"
                  :key="item.compId"
                  :label="item.compName"
                  :value="item.compId"
                ></el-option>
              </el-select>
            </div>
            <div
              title="课程名称"
              class="searchboxItem ci-full"
              v-show="screen != 'screen'"
            >
              <span class="itemLabel">课程名称:</span>
              <el-input
                v-model="CourseName"
                type="text"
                size="small"
                placeholder="请输入课程名称"
                clearable
              />
            </div>
            <div title="学习进度" class="searchboxItem ci-full">
              <span class="itemLabel">学习进度:</span>
              <el-select
                v-model="studyProgress"
                clearable
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="item in LearningstateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="searchbox" style="padding-top: 10px">
            <div
              title="机构名称"
              class="searchboxItem ci-full"
              v-show="screen != 'screen'"
            >
              <span class="itemLabel">机构名称:</span>
              <el-select
                size="small"
                v-model="compId2"
                remote
                :remote-method="getCompanyList"
                filterable
                clearable
                placeholder="请至少输入两个字搜索"
                style="width: 100%"
              >
                <el-option
                  v-for="item in CompanyList"
                  :key="item.compId"
                  :label="item.compName"
                  :value="item.compId"
                ></el-option>
              </el-select>
            </div>
            <div
              title="班级名称"
              class="searchboxItem ci-full"
              v-show="screen != 'screen'"
            >
              <span class="itemLabel">班级名称:</span>
              <el-select
                @change="
                  (val) => {
                    clean(val, 'projectId');
                  }
                "
                size="small"
                v-model="projectId"
                :remote-method="getClassList"
                remote
                filterable
                clearable
                placeholder="请输入班级名称"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.projectId"
                  :label="item.projectName"
                  :value="item.projectId"
                ></el-option>
              </el-select>
            </div>
            <div
              title="所属区域"
              class="searchboxItem ci-full"
              v-show="showAreaNm"
            >
              <span class="itemLabel">所属区域:</span>
              <el-cascader
                v-model="userClassAreaId"
                :options="areatreeList"
                clearable
                :props="propsarea"
                size="small"
              ></el-cascader>
            </div>
            <div class="df">
              <el-button type="primary" class="bgc-bv" round @click="getData()"
                >查询</el-button
              >
              <el-button type="primary" class="bgc-bv" round @click="getModel()"
                >导出</el-button
              >
              <el-button
                type="primary"
                class="bgc-bv"
                round
                @click="getScreenCapture()"
                v-show="screen"
                >截屏备案</el-button
              >
              <el-button class="bgc-bv" round @click="customOpen" size="small"
                >自定义表头</el-button
              >
            </div>
          </div>
        </div>
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-table
              ref="multipleTable"
              :data="tableData"
              :height="tableHeight"
              size="small"
              tooltip-effect="dark"
              style="width: 100%"
              :header-cell-style="tableHeader"
              stripe
              v-if="showtable"
            >
              <el-table-column
                label="序号"
                align="center"
                type="index"
                :index="indexMethod"
                width="120"
                fixed
              />
              <el-table-column
                label="姓名"
                align="left"
                show-overflow-tooltip
                prop="userName"
                min-width="150"
                fixed
              />
              <el-table-column
                label="身份证号"
                align="left"
                show-overflow-tooltip
                prop="idcard"
                min-width="150"
              />
              <!-- <el-table-column
                label="班级名称"
                align="left"
                show-overflow-tooltip
                prop="projectName"
                width="250"
              />
              <el-table-column
                label="机构名称"
                align="left"
                show-overflow-tooltip
                prop="compName"
                width="200"
              />
              <el-table-column
                label="课程名称"
                align="left"
                show-overflow-tooltip
                prop="courseName"
                width="260"
              />
              <el-table-column
                label="应修学时"
                align="right"
                show-overflow-tooltip
                prop="requireLessonNumMust"
              />
              <el-table-column
                label="已修学时"
                align="right"
                show-overflow-tooltip
                prop="studyLessonNum"
              />
              <el-table-column
                label="累计在线学习时长"
                align="right"
                show-overflow-tooltip
                width="140px"
              >
                <template slot-scope="scope">
                  <span>{{ getTime(scope.row.totalTimeSum) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="最后一次学习时间"
                align="left"
                show-overflow-tooltip
                width="140px"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.endLastTime | moment }}</span>
                </template>
              </el-table-column>
              <el-table-column label="学习进度" align="left">
                <span
                  v-if="scope.row.studyProgress != '40'"
                  slot-scope="scope"
                  >{{
                    $setDictionary("LEARNINGSTATE", scope.row.studyProgress)
                  }}</span
                >
                <el-tooltip
                  v-else
                  class="item"
                  effect="dark"
                  :content="scope.row.notCompleteReasons"
                  placement="top"
                >
                  <span
                    style="cursor: pointer; display: flex;justify-content: flex-start;"
                    >{{
                      $setDictionary("LEARNINGSTATE", scope.row.studyProgress)
                    }}</span
                  >
                </el-tooltip>
              </el-table-column>
              <el-table-column
                label="所属企业"
                align="left"
                show-overflow-tooltip
                prop="userCompName"
                width="200"
              /> -->
              <template v-if="tableHaed.length">
                <el-table-column
                  v-for="(el, index) in tableHaed"
                  :key="index"
                  :label="el.label"
                  :align="el.textAlign"
                  :show-overflow-tooltip="el.propName != 'studyProgress'"
                  :min-width="el.width"
                >
                  <template slot-scope="scope">
                    <el-tooltip
                      v-if="
                        el.propName == 'studyProgress' &&
                        scope.row.studyProgress == '40'
                      "
                      class="item"
                      effect="dark"
                      :content="scope.row.notCompleteReasons"
                      placement="top"
                    >
                      <span style="cursor: pointer">
                        {{ getValue(el, scope.row) }}
                      </span>
                    </el-tooltip>
                    <template v-else>
                      {{ getValue(el, scope.row) }}
                    </template>
                  </template>
                </el-table-column>
              </template>
              <el-table-column
                label="操作"
                align="left"
                width="200"
                fixed="right"
              >
                <template slot-scope="scope">
                  <div>
                    <el-button
                      v-show="!$route.query.temporary"
                      style="padding: 0 5px"
                      type="text"
                      size="mini"
                      @click="
                        lookStudyRecord(scope.row.userId, scope.row.projectId)
                      "
                      >查看学习记录</el-button
                    >
                    <el-button
                      type="text"
                      style="padding: 0 5px"
                      size="mini"
                      @click="handleTrajectory(scope.row)"
                      >查看学习轨迹</el-button
                    >
                    <el-button
                     v-show="!$route.query.temporary"
                      style="padding: 0 5px"
                      type="text"
                      size="mini"
                      @click="
                        lookupTrainCert(scope.row.projectId, scope.row.userId)
                      "
                      :disabled="scope.row.studyProgress != 30"
                      >查看学时证明</el-button
                    >
                    <el-button
                      v-show="!$route.query.temporary"
                      style="padding: 0 5px"
                      type="text"
                      size="mini"
                      @click="
                        lookupTrainDocument(
                          scope.row.projectId,
                          scope.row.userId
                        )
                      "
                      :disabled="scope.row.studyProgress != 30"
                      >查看学员档案</el-button
                    >
                    <el-button
                      type="text"
                      style="padding: 0px 5px"
                      size="mini"
                      @click="viewLogZT(scope.row)"
                      >查看日志</el-button
                    >
                  </div>
                </template>
              </el-table-column>
              <Empty slot="empty" />
            </el-table>
          </div>
        </div>
        <PageNum
          :apiData="apiData"
          @sizeChange="sizeChange"
          @getData="getData"
        />
      </div>
    </div>
    <el-dialog
      title="查看学员档案"
      :visible.sync="dialogDownload"
      width="50%"
      center
      :before-close="closeDownloadTrainDocument"
    >
      <div id="pdf-content" style="height: 800px"></div>
    </el-dialog>
    <el-dialog
      title="查看学时证明"
      :visible.sync="dialogCert"
      width="50%"
      center
      :before-close="closeDownloadCert"
    >
      <div id="pdf-cert" style="height: 800px"></div>
    </el-dialog>

    <el-dialog
      title="导出提示"
      :visible.sync="modelState"
      width="400px"
      top="5%"
      :center="true"
      :before-close="closeDocsDialog"
    >
      <div class="model">
        <div class="conTip">
          导出数据仅限于业务范围内使用，不得用于其它用途，如因个人原因导致数据泄露，由个人承担法律责任。
        </div>
        <div class="flexca">
          <div class="flexac" style="width: 10rem; margin-right: 10px">
            <!-- <span class="itemLabel">请选择导出范围:</span> -->
            <el-select
              size="small"
              v-model="exportName"
              @change="changeLoadType"
            >
              <el-option value="projectName" label="班级名称"></el-option>
              <el-option value="projectCode" label="班级编码"></el-option>
              <el-option value="compName" label="机构名称"></el-option>
            </el-select>
          </div>
          <el-select
            v-if="exportName == 'projectName'"
            size="small"
            v-model="classId"
            :remote-method="getClassListModel"
            remote
            filterable
            clearable
            placeholder="请输入班级名称"
            style="width: 17rem"
          >
            <el-option
              v-for="item in classListModel"
              :key="item.projectId"
              :label="item.projectName"
              :value="item.projectId"
            ></el-option>
          </el-select>
          <el-input
            v-model="projectCode"
            v-else-if="exportName == 'projectCode'"
            size="small"
            placeholder="请输入班级编码"
            style="width: 17rem"
          ></el-input>
          <!-- <el-input
            v-model="compName"
           
            size="small"
            placeholder="请输入班级编码"
            style="width: 17rem"
          ></el-input> -->
          <el-select
            v-else
            size="small"
            v-model="compId"
            remote
            :remote-method="getCompanyList2"
            filterable
            clearable
            placeholder="请至少输入两个字搜索"
            style="width: 100%"
          >
            <el-option
              v-for="item in CompanyList2"
              :key="item.compId"
              :label="item.compName"
              :value="item.compId"
            ></el-option>
          </el-select>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; justify-content: center"
      >
        <div>
          <el-button class="bgc-bv" @click="confirmDocsDialog">确定</el-button>
          <el-button @click="closeDocsDialog">取消</el-button>
        </div>
      </span>
    </el-dialog>
    <!-- <el-dialog
      title="导出提示"
      :visible.sync="modelState"
      width="400px"
      top="5%"
      :center="true"
      :before-close="closeDocsDialog"
    >
      <div class="model">
        <div class="conTip">
          导出数据仅限于业务范围内使用，不得用于其它用途，如因个人原因导致数据泄露，由个人承担法律责任。
        </div>
        <div title="请选择导出范围" class="searchboxItem">
          <span class="itemLabel">请选择导出范围:</span>
          <el-select
            size="small"
            v-model="classId"
            :remote-method="getClassListModel"
            remote
            filterable
            clearable
            placeholder="请输入班级名称"
          >
            <el-option
              v-for="item in classListModel"
              :key="item.projectId"
              :label="item.projectName"
              :value="item.projectId"
            ></el-option>
          </el-select>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; justify-content: center;"
      >
        <div>
          <el-button class="bgc-bv" @click="confirmDocsDialog">确定</el-button>
          <el-button @click="closeDocsDialog">取消</el-button>
        </div>
      </span>
    </el-dialog> -->
    <el-dialog
      title="截屏备案"
      :visible.sync="ScreenCapturedialog"
      width="50%"
      top="2%"
      center
      :before-close="closeScreenCapture"
    >
      <div id="pdf-Screen" style="height: 600px"></div>
    </el-dialog>
    <el-dialog
      title="自定义表头"
      :visible.sync="tableHeadDialog"
      width="30%"
      class="custom"
      @close="cencal"
    >
      <p style="padding-left: 20px; margin-bottom: 10px">
        勾选需要显示在列表上的项，可拖动调整顺序
      </p>
      <div>
        <el-tree
          ref="headTree"
          :data="treeDataCopy"
          default-expand-all
          draggable
          :allow-drop="allowDrop"
          :allow-drag="allowDrag"
        >
          <template slot-scope="{ node, data }">
            <el-checkbox
              @change="
                (val) => {
                  handleCheckChange(val, data);
                }
              "
              v-model="data.checked"
              >{{ node.label }}</el-checkbox
            >
          </template>
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cencal">取 消</el-button>
        <el-button class="bgc-bv" @click="resetHeadOk">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import PageNum from "@/components/PageNum.vue";
import List from "@/mixins/List";
import moment from "moment";
import { mapGetters } from "vuex";
import pdf from "pdfobject";
import { Message } from "element-ui";
import { resetKeepAlive } from "@/utils/common";
export default {
  name: "StudentLearningRecord",
  components: {
    Empty,
    PageNum,
  },
  mixins: [List],
  data() {
    return {
      // 导出
      projectCode: "",
      exportName: "projectName", // 导出名称
      // classListModel: [],
      //
      modelState: false, //弹框
      ScreenCapturedialog: false, //弹框
      ScreenCapture: false, //弹框
      classId: "",
      classListModel: [],
      projectList: [],
      userName: "",
      idCard: "",
      CourseName: "",
      areaId: "",
      projectId: "",
      userCompId: "",
      userCompanyList: [],
      compId: "",
      compId2: "",
      userClassAreaId:'',//所属区划
      showAreaNm:false, //是否是内蒙监管登录
      CompanyList: [],
      LearningstateList: [], // 单位类型
      studyProgress: "",
      dialogDownload: false,
      dialogCert: false,
      areatreeList: [], // 行政区划
      selectDate: {
        areaId: "",
        compName: "",
        compType: "",
        endDateLong: "",
        startDateLong: "",
      },
      propsarea: {
        value: "value",
        label: "label",
        emitPath: false,
        checkStrictly: true,
      },
      // 自定义表头
      showtable: false,
      tableHeadDialog: false, //
      treeData: [
        {
          label: "班级名称", //表头名称
          propName: "projectName", //后台对应字段名称
          textAlign: "left", //文字对齐方式e
          renderType: "", //渲染类型
          timeType: "", //时间字段的渲染类型
          dictionaries: "", //字典对应key
          width: "250", // 列的宽
          order: 1,
          id: "1",
          checked: true,
        },
        {
          label: "机构名称", //表头名称
          propName: "compName", //后台对应字段名称
          textAlign: "left", //文字对齐方式e
          renderType: "", //渲染类型
          timeType: "", //时间字段的渲染类型
          dictionaries: "", //字典对应key
          width: "200", // 列的宽
          order: 2,
          id: "2",
          checked: true,
        },
        {
          label: "课程名称", //表头名称
          propName: "courseName", //后台对应字段名称
          textAlign: "left", //文字对齐方式e
          renderType: "", //渲染类型
          timeType: "", //时间字段的渲染类型
          dictionaries: "", //字典对应key
          width: "260", // 列的宽
          order: 3,
          id: "3",
          checked: true,
        },
        {
          label: "应修学时", //表头名称
          propName: "requireLessonNumMust", //后台对应字段名称
          textAlign: "right", //文字对齐方式e
          renderType: "", //渲染类型
          timeType: "", //时间字段的渲染类型
          dictionaries: "", //字典对应key
          width: "100", // 列的宽
          order: 4,
          id: "4",
          checked: true,
        },
        {
          label: "已修学时", //表头名称
          propName: "studyLessonNum", //后台对应字段名称
          textAlign: "right", //文字对齐方式e
          renderType: "", //渲染类型
          timeType: "", //时间字段的渲染类型
          dictionaries: "", //字典对应key
          width: "100", // 列的宽
          order: 5,
          id: "5",
          checked: true,
        },
        {
          label: "累计在线学习时长", //表头名称
          propName: "totalTimeSum", //后台对应字段名称
          textAlign: "right", //文字对齐方式e
          renderType: "time", //渲染类型
          timeType: "custom", //时间字段的渲染类型
          dictionaries: "", //字典对应key
          width: "140", // 列的宽
          order: 6,
          id: "6",
          checked: true,
        },
        // {
        //   label: "最后一次学习时间", //表头名称
        //   propName: "endLastTime", //后台对应字段名称
        //   textAlign: "left", //文字对齐方式e
        //   renderType: "time", //渲染类型
        //   timeType: "moment", //时间字段的渲染类型
        //   dictionaries: "", //字典对应key
        //   width: "140", // 列的宽
        //   order: 7,
        //   id: "7",
        //   checked: true,
        // },
        {
          label: "学习进度", //表头名称
          propName: "studyProgress", //后台对应字段名称
          textAlign: "left", //文字对齐方式e
          renderType: "status", //渲染类型
          timeType: "", //时间字段的渲染类型
          dictionaries: "LEARNINGSTATE", //字典对应key
          width: "80", // 列的宽
          order: 8,
          id: "8",
          checked: true,
        },
        {
          label: "所属企业", //表头名称
          propName: "userCompName", //后台对应字段名称
          textAlign: "left", //文字对齐方式e
          renderType: "", //渲染类型
          timeType: "", //时间字段的渲染类型
          dictionaries: "", //字典对应key
          width: "200", // 列的宽
          order: 9,
          id: "9",
          checked: true,
        },
        {
          label: "结业考试成绩", //表头名称
          propName: "paperScore", //后台对应字段名称
          textAlign: "right", //文字对齐方式e
          renderType: "", //渲染类型
          timeType: "", //时间字段的渲染类型
          dictionaries: "", //字典对应key
          width: "200", // 列的宽
          order: 10,
          id: "10",
          checked: true,
        },
        {
          label: "所属区域", //表头名称
          propName: "userClassAreaName", //后台对应字段名称
          textAlign: "right", //文字对齐方式e
          renderType: "", //渲染类型
          timeType: "", //时间字段的渲染类型
          dictionaries: "", //字典对应key
          width: "200", // 列的宽
          order: 11,
          id: "11",
          checked: true,
        },
      ],
      tableHaed: [],
      treeDataCopy: [],
      CompanyList2: [],
      search: {
        projectId: true,
      },
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (oldVal.path != "/web/StudentLearningRecordall") {
          this.areaId = "";
          this.screen = "";
          this.getData(-1);
        }
      },
      // 深度观察监听
      deep: true,
    },

    classId: function (val) {
      if (val == "") {
        this.classListModel = [];
      }
    },
  },
  created() {
    this.areaId = this.$route.query.areaId;
    this.screen = this.$route.query.stu;
    this.projectName = this.$route.query.projectName;
    this.projectId = this.$route.query.projectId || "";
    this.getTableHeight();
    this.getLearningstateList();
    this.getareatree();
    this.getClassListId(this.projectId);
    //
    this.getTableHead();
    if(this.userJson.areaId.indexOf('150') > -1 || this.userJson.areaId.indexOf('152') > -1 || this.userJson.areaId.indexOf('159') > -1) {
      this.showAreaNm = true;
    } else {
      this.showAreaNm = false;
    }
  },
   computed: {
    ...mapGetters({
      userJson: "getUser",
    }),
  },
  methods: {
    // 查看暂停日志
    viewLogZT(row) {
      ;
      // return
      let rowJson = {
        userId: row.userId,
        projectCourseId: row.projectCourseId,
        projectName: row.projectName,
        courseName: row.courseName,
        userName: row.userName,
        idcard: row.idcard,
        mobile: row.mobile,
        projectId: row.projectId,
      };
      let data = JSON.stringify(rowJson);
      ;
      this.$router.push({
        path: "/web/operate/studentStatisticsJournalZT",
        query: {
          data,
          userId: row.userId,
          projectCourseId: row.projectCourseId,
          pageTitle: '查看日志'
        },
      });
    },
    // 导出
    changeLoadType() {
      this.classId = "";
      this.projectCode = "";
      this.compName = "";
    },
    /**
     * 自定义表头
     */
    getValue(el, row) {
      // 状态
      if (el.renderType == "status") {
        // if(el.propName == 'studyProgress' && row[el.propName] != '40'){
        //   $setDictionary("LEARNINGSTATE", scope.row.studyProgress)
        // }
        return this.$setDictionary(el.dictionaries, row[el.propName]);
      } else if (el.renderType == "time") {
        // 时间
        if (el.timeType == "moment") {
          return row[el.propName]
            ? this.$moment(row[el.propName]).format("YYYY-MM-DD HH:mm:ss")
            : "--";
        } else if (el.timeType == "custom") {
          return this.getTime(row[el.propName]);
        } else {
          return row[el.propName];
        }
      } else {
        // 其他
        return row[el.propName] || "--";
      }
    },
    // 自定义确定
    resetHeadOk() {
      let list = [];
      let saveData = [];
      this.treeDataCopy.forEach((el, index) => {
        saveData.push({ id: el.id, order: index, checked: el.checked });
        if (el.checked) {
          list.push(el);
        }
      });
      this.tableHaed = list;
      this.tableHeadDialog = false;
      this.$post("/sys/admin/savePageConfig", {
        configInfo: JSON.stringify(saveData),
        pageName: "StudentLearningRecord",
      }).then((res) => {
        // ;
        this.getTableHead();
      });
    },
    customOpen() {
      this.tableHeadDialog = true;
      this.handle();
    },
    cencal() {
      this.tableHeadDialog = false;
    },
    getTableHead() {
      this.$post("/sys/admin/findAdminConfig", {
        pageName: "StudentLearningRecord",
      })
        .then((res) => {
          if (res.status == 0) {
            const data = res.data || {};
            let list = [];
            if (data.configInfo && data.configInfo != "") {
              list = JSON.parse(data.configInfo);
            }
            if (list.length) {
              list.map((el) => {
                this.treeData.forEach((it, index) => {
                  if (el.id == it.id) {
                    it.checked = el.checked;
                    it.order = el.order;
                  }
                });
              });
              this.treeData.sort((a, b) => {
                return a.order - b.order;
              });
              this.handle();
            } else {
              this.handle();
            }
          } else {
            this.handle();
            // this.tableHaed = [...this.treeData];
          }
        })
        .catch((err) => {
          this.tableHaed = [...this.treeData];
        });
    },
    handle() {
      this.tableHaed = [];
      this.treeDataCopy = [];
      this.treeData.forEach((el) => {
        this.treeDataCopy.push(Object.assign({}, el));
      });
      this.treeDataCopy.forEach((el) => {
        if (el.checked) {
          this.tableHaed.push(el);
        }
      });
      this.showtable = true;
    },
    // 判断拖拽的位置
    allowDrop(draggingNode, dropNode, type) {
      return type !== "inner";
    },
    // 节点是否可以拖拽
    allowDrag(draggingNode) {
      return true;
    },
    handleCheckChange(val, data) {
      // console.log(data);
    },
    //
    getModel() {
      this.modelState = true;
    },
    closeDocsDialog() {
      this.modelState = false;
    },
    // 截屏备案
    getScreenCapture() {
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      if (this.userName) {
        params.userName = this.userName;
      }
      if (this.idCard) {
        params.idcard = this.idCard;
      }
      if (this.CourseName) {
        params.courseName = this.CourseName;
      }
      if (this.studyProgress) {
        params.studyProgress = this.studyProgress;
      }
      if (this.projectId) {
        params.projectId = this.projectId;
      }

      if (this.$route.query.projectId) {
        params.projectId = this.$route.query.projectId;
      }
      if (this.areaId || this.$route.query.areaId) {
        params.areaId = this.areaId || this.$route.query.areaId;
      }
      if (this.selectDate.compName) {
        params.compName = this.selectDate.compName;
      }
      if (this.selectDate.compType) {
        params.compType = this.selectDate.compType;
      }
      if (this.entrytime) {
        params.startDateLong = this.entrytime[0];
        params.endDateLong = this.entrytime[1];
      }
      this.$post("/gov/project/userStudyRecordExport", params).then((res) => {
        if (res.status == 0) {
          this.ScreenCapturedialog = true;
          this.$nextTick(() => {
            pdf.embed(res.data, "#pdf-Screen");
          });
        } else {
          this.$message.warning({ message: res.message, duration: 1500 });
        }
      });
    },
    // 弹框导出确定
    confirmDocsDialog() {
      const dataKey =
        this.exportName == "projectName"
          ? "projectId"
          : this.exportName == "compName"
          ? "compId"
          : "projectCode";
      const dataValue =
        dataKey == "projectId"
          ? "classId"
          : dataKey == "compId"
          ? "compId"
          : "projectCode";
      if (this[dataValue] != "") {
        this.$post("/gov/project/page-export", {
          // projectId: this.classId
          [dataKey]: this[dataValue],
        })
          .then((res) => {
            if (res.status == 0) {
              window.open(res.data);
              this.modelState = false;
              this[dataValue] = "";
            }
          })
          .catch(() => {
            return;
          });
      } else {
        Message.error({
          message: "请输入班级名称或班级编码或机构名称",
          duration: "1000",
        });
      }
    },
    // 班级名称搜索列表
    getClassListModel(query) {
      if (query.trim()) {
        this.$post("/biz/project/queryProjectNameList", { projectName: query })
          .then((res) => {
            if (res.status == 0) {
              this.classListModel = res.data || [];
            }
          })
          .catch(() => {
            return;
          });
      } else {
        this.classListModel = [];
      }
    },
    //班级列表通过ID
    getClassListId(query) {
      if (query.trim()) {
        this.$post("/biz/project/queryProjectNameList", { projectId: query })
          .then((res) => {
            if (res.status == 0) {
              this.projectList = res.data || [];
            }
          })
          .catch(() => {
            return;
          });
      } else {
        this.projectList = [];
      }
    },
    getClassList(query) {
      if (query.trim()) {
        this.$post("/biz/project/queryProjectNameList", { projectName: query })
          .then((res) => {
            if (res.status == 0) {
              this.projectList = res.data || [];
            }
          })
          .catch(() => {
            return;
          });
      } else {
        this.projectList = [];
      }
    },
    /* 所属企业 */
    getuserCompanyList(query) {
      if (query.trim().length >= 2) {
        this.$post("/sys/company/queryCompanyList", { compName: query })
          .then((res) => {
            if (res.status == 0) {
              this.userCompanyList = res.data || [];
            }
          })
          .catch(() => {
            return;
          });
      } else {
        this.userCompanyList = [];
      }
    },
    /* 所属企业 */
    getCompanyList(query) {
      if (query.trim().length >= 2) {
        this.$post("/sys/company/queryCompanyList", { compName: query })
          .then((res) => {
            if (res.status == 0) {
              this.CompanyList = res.data || [];
            }
          })
          .catch(() => {
            return;
          });
      } else {
        this.CompanyList = [];
      }
    },
    /* 所属企业 */
    getCompanyList2(query) {
      if (query.trim().length >= 2) {
        this.$post("/sys/company/queryCompanyList", { compName: query })
          .then((res) => {
            if (res.status == 0) {
              this.CompanyList2 = res.data || [];
            }
          })
          .catch(() => {
            return;
          });
      } else {
        this.CompanyList2 = [];
      }
    },
    getData(pageNum = 1) {
      const params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
      };
      if (this.userName) {
        params.userName = this.userName;
      }
      if (this.userCompId) {
        params.userCompId = this.userCompId;
      }
      if (this.compId2) {
        params.compId = this.compId2;
      }
      if (this.idCard) {
        params.idcard = this.idCard;
      }
      if (this.CourseName) {
        params.courseName = this.CourseName;
      }
      if (this.studyProgress) {
        params.studyProgress = this.studyProgress;
      }
      if (this.search.projectId) {
        params.projectId = this.$route.query.projectId;
      }
      if (this.projectId) {
        params.projectId = this.projectId;
      }
      if (this.areaId || this.$route.query.areaId) {
        params.areaId = this.areaId || this.$route.query.areaId;
      }
      if (this.selectDate.compName) {
        params.compName = this.selectDate.compName;
      }
      if (this.selectDate.compType) {
        params.compType = this.selectDate.compType;
      }
      if (this.entrytime) {
        params.startDateLong = this.entrytime[0];
        params.endDateLong = this.entrytime[1];
      }
      if (this.userClassAreaId) {
        params.userClassAreaId = this.userClassAreaId;
      }
      this.doFetch({
        url: "/gov/project/queryUserStudyRecordList",
        params,
        pageNum,
      });
    },
    clean(val, name) {
      this.projectId = val;
      this.search[name] = false;
    },
    getTableHeight(opDom = true, page = true) {
      let tHeight =
        window.innerHeight -
        (3 + 1.35 + 3.25 + 0.675 + 2 + 1.35 + 1.35 + 3) * 16;
      if (opDom) {
        tHeight -= 40 + 0.675 * 16 + 5;
      }
      if (page) {
        tHeight -= 32;
      }
      this.tableHeight = tHeight;
    },
    getLearningstateList() {
      const LearningstateList = this.$setDictionary("LEARNINGSTATE", "list");
      const list = [];
      for (const key in LearningstateList) {
        list.push({
          value: key,
          label: LearningstateList[key],
        });
      }
      this.LearningstateList = list;
    },
    /* 查看学习记录 */
    lookStudyRecord(userId, projectId) {
      this.$router.push({
        path: "/web/ViewLearningRecords",
        query: {
          userId,
          projectId,
          needHold2: true,
        },
      });
    },
    lookupTrainDocument(projectId, userId) {
      let parmar = {
        projectId: projectId,
        userId: userId,
      };
      this.$post("/cert/downloadTrainDocument", parmar).then((res) => {
        if (res.status == 0) {
          this.dialogDownload = true;
          this.$nextTick(() => {
            pdf.embed(res.data, "#pdf-content");
          });
        } else {
          that.$message.warning({ message: res.message, duration: 1500 });
        }
      });
    },
    closeDownloadTrainDocument() {
      this.dialogDownload = false;
    },
    lookupTrainCert(projectId, userId) {
      let parma = {
        projectId: projectId,
        userId: userId,
      };
      this.$post("/cert/downloadCert", parma).then((res) => {
        if (res.status == 0) {
          this.dialogCert = true;
          this.$nextTick(() => {
            pdf.embed(res.data, "#pdf-cert");
          });
        } else {
          that.$message.warning({ message: res.message, duration: 1500 });
        }
      });
    },
    getareatree() {
      this.$post("/gov/area/tree").then((ret) => {
        this.areatreeList = ret.data;
      });
    },
    getTime(val) {
      if (!val) {
        return "0秒";
      }
      let h = parseInt(val / 60 / 60);
      let m = parseInt((val % 3600) / 60);
      let s = val % 60;
      if (h < 9) {
        h = "0" + h;
      }
      if (m < 9) {
        m = "0" + m;
      }
      if (s < 9) {
        s = "0" + s;
      }
      return (
        (h != "00" ? h + "时" : "") +
          (m != "00" ? m + "分" : "") +
          (s != "00" ? s + "秒" : "") || ""
      );
    },
    /* 查看学习轨迹 */
    handleTrajectory(row) {
      let rowJson = {
        userId: row.userId,
        projectCourseId: row.projectCourseId,
        projectName: row.projectName,
        courseName: row.courseName,
        userName: row.userName,
        idcard: row.idcard,
        mobile: row.mobile,
      };
      let data = JSON.stringify(rowJson);
      this.$router.push({
        path: "/web/personStudyTrajectoryList",
        query: {
          data,
          userId: row.userId,
          projectCourseId: row.projectCourseId,
          projectId: row.projectId,
        },
      });
    },
  },
  beforeRouteLeave: resetKeepAlive,
};
</script>
<style lang="less" scoped>
.searchBox {
  .el-icon-arrow-down:before {
    content: "\e6df" !important;
  }
}
.model {
  .conTip {
    text-align: justify;
    margin-bottom: 20px;
  }
  .itemLabel {
    margin: 10px 0;
  }
}
</style>
